const ENV = {
  API_TIMEOUT_DURATION: import.meta.env.VITE_API_TIMEOUT_DURATION,
  API_ENDPOINT: import.meta.env.VITE_API_ENDPOINT,
  FLOG_ENDPOINT: import.meta.env.VITE_FLOG_ENDPOINT,
  VIEW_TRACKER_ENDPOINT: import.meta.env.VITE_VIEW_TRACKER_ENDPOINT,
  GOOGLE_GTM_ID: import.meta.env.VITE_GOOGLE_GTM_ID,
  CRYPTO_SECRET: import.meta.env.VITE_CRYPTO_SECRET,
  BACKOFFICE_URL: import.meta.env.VITE_BACKOFFICE_URL,
  CHATYME_CLIENT_APP_URL: import.meta.env.VITE_CHATYME_CLIENT_APP_URL,
  CHATYME_CHAT_APP_URL: import.meta.env.VITE_CHATYME_CHAT_APP_URL,
  API_SWAGGER_URL: import.meta.env.VITE_API_SWAGGER_URL,
  API_SWAGGER_FILTER_BY_CONSUMER: import.meta.env.VITE_API_SWAGGER_FILTER_BY_CONSUMER
};

export default ENV;
